import { render, staticRenderFns } from "./dynamic_content.vue.js?vue&type=template&id=0e48bde0!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dynamic_content.vue?vue&type=template&id=0e48bde0"
import script from "./dynamic_content.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dynamic_content.vue?vue&type=script&lang=js"
export * from "./dynamic_content.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dynamic_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports